/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For the first two races, predictions are based on 2025 data and may be less accurate than usual. Accuracy improves significantly from Race 3 onwards.`)
};

const es_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para las dos primeras carreras, las predicciones se basan en datos de 2025 y pueden ser menos precisas de lo habitual. La precisión mejora significativamente a partir de la Carrera 3.`)
};

const de_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die ersten beiden Rennen basieren die Prognosen auf 2025-Daten und können weniger genau sein. Die Genauigkeit verbessert sich ab Rennen 3 deutlich.`)
};

const nl_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voor de eerste twee races zijn voorspellingen gebaseerd op 2025-gegevens en kunnen minder nauwkeurig zijn dan gebruikelijk. De nauwkeurigheid verbetert aanzienlijk vanaf race 3.`)
};

const fr_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les deux premières courses, les prédictions sont basées sur les données 2025 et peuvent être moins précises que d’habitude. La précision s’améliore significativement à partir de la course 3.`)
};

const it_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per le prime due gare, le previsioni si basano sui dati 2025 e possono essere meno accurate del solito. La precisione migliora significativamente dalla Gara 3 in poi.`)
};

const pt_br2_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para as duas primeiras corridas, as previsões são baseadas em dados de 2025 e podem ser menos precisas que o normal. A precisão melhora significativamente a partir da Corrida 3.`)
};

const pt_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nas duas primeiras corridas, as previsões baseiam-se em dados de 2025 e podem ser menos precisas do que o habitual. A precisão melhora significativamente a partir da corrida 3.`)
};

const ja_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の2レースは2025年データに基づく予測のため、通常より精度が低い場合があります。レース3以降は精度が大幅に向上します。`)
};

const zh_f1_apex_early_season_note = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前两场比赛的预测基于2025年数据，可能不如平时准确。从第3场比赛起准确度将显著提高。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_early_season_note = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_early_season_note(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_early_season_note", locale)
	if (locale === "en") return en_f1_apex_early_season_note(inputs)
	if (locale === "es") return es_f1_apex_early_season_note(inputs)
	if (locale === "de") return de_f1_apex_early_season_note(inputs)
	if (locale === "nl") return nl_f1_apex_early_season_note(inputs)
	if (locale === "fr") return fr_f1_apex_early_season_note(inputs)
	if (locale === "it") return it_f1_apex_early_season_note(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_early_season_note(inputs)
	if (locale === "pt") return pt_f1_apex_early_season_note(inputs)
	if (locale === "ja") return ja_f1_apex_early_season_note(inputs)
	return zh_f1_apex_early_season_note(inputs)
};